import { FETCH_CAMPAIGN_LIST_BEGIN,
  FETCH_CAMPAIGN_LIST_SUCCESS,
  FETCH_CAMPAIGN_LIST_FAILURE
} from '../actions/campaignList';
const initialState = {
  campaignList: [],
  page: null,
  nextPage: null,
  loading: false,
  error: null,
  isLastPage: false
};

export default function campaignList(state = initialState, action) {
  switch (action.type) {
  case FETCH_CAMPAIGN_LIST_BEGIN:
      // Mark the state as "loading" so we can show a spinner or something
      // Also, reset any errors. We're starting fresh.
    return {
      ...state,
      loading: true,
      error: null
    };

  case FETCH_CAMPAIGN_LIST_SUCCESS:
    // All done: set loading "false".
    // Also, replace the items with the ones from the server
    let campaignList = state.campaignList.concat(action.payload.campaigns);
    return {
      ...state,
      campaignList,
      page: action.payload.page,
      nextPage: action.payload.next_page,
      isLastPage: action.payload.is_last_page,
      loading: false,
      error: null
    };

  case FETCH_CAMPAIGN_LIST_FAILURE:
    return {
      ...state,
      loading: false,
      error: action.payload.error,
    };
  default:
      // ALWAYS have a default case in a reducer
    return state;
  }
}
